import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import './index .css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="not-found-page"
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
      }}
    >
      {/* 视频背景 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src={`${process.env.PUBLIC_URL}/iTab-.mp4`} type="video/mp4" />
        您的浏览器不支持视频播放。
      </video>
      
      {/* 半透明遮罩层 */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 0,
        }}
      />
      
      {/* 404内容 - 半透明效果 */}
      <div 
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.5)', // ← 透明度控制
          backdropFilter: 'blur(10px)', // 毛玻璃效果
          borderRadius: '20px',
          padding: '60px 40px',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          maxWidth: '500px',
          width: '90%',
          zIndex: 1,
        }}
      >
        <Result
          status="404"
          title="404"
          subTitle="抱歉，您访问的页面不存在。"
          style={{
            backgroundColor: 'transparent',
          }}
          extra={
            <Button 
              type="primary" 
              onClick={() => navigate('/')}
              size="large"
              style={{
                backgroundColor: 'rgba(24, 144, 255, 0.9)',
                borderColor: 'rgba(24, 144, 255, 0.9)',
                backdropFilter: 'blur(3px)',
                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)',
                height: '48px',
                padding: '0 32px',
                fontSize: '16px',
              }}
            >
              返回首页
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default NotFound;